import * as React from "react";

import { ICheckboxProps } from "./Checkbox";
import { CheckboxGroup } from ".";

const defaultCheckBoxOptions: ICheckboxProps[] = [
	{
		name: "",
		label: "",
		checked: false,
	},
];

interface IProps {
	/** Sets the title that will appear at the top of the list */
	title?: {};
	name: string;

	className?: string;
	children?: {};
	/** Specifies an event handler to run when one or more of the checkboxes is checked or unchecked.
	 * The values array passed to this handler will have all of the Code values for each item that is selected.
	 */
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	selectedValues?: string[];
	disabled?: boolean;
	pickListCode: string;
	// own props
	/** Used internally by the component to hold the array of PickListItemResponseDTO retrieved from Redux.
	 * DO NOT set this property externally.
	 */
	pickListItems: PickListItemResponseDTO[];
}

class PickListCheckboxGroup extends React.Component<IProps> {
	private checkboxOptions = defaultCheckBoxOptions;

	public UNSAFE_componentWillReceiveProps(nextProps: IProps) {
		this.checkboxOptions = nextProps.pickListItems.map(
			(p: PickListItemResponseDTO) => {
				return { id: p.id!.toString(), name: p.code!, label: p.description! };
			}
		);
	}

	public render() {
		const values = this.props.selectedValues;
		this.checkboxOptions.forEach((check) => {
			if (values == null) {
				check.checked = false;
				return;
			}

			if (values.indexOf(check.name) > -1) {
				check.checked = true;
			} else {
				check.checked = false;
			}
		});
		return (
			<CheckboxGroup
				checkOptions={this.checkboxOptions}
				className={this.props.className}
				disabled={this.props.disabled}
				children={this.props.children}
				name={this.props.name}
				title={this.props.title}
				onUpdate={this.props.onChange}
				values={this.props.selectedValues || []}
			/>
		);
	}
}

export default PickListCheckboxGroup;
